/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
var Platform;
(function (Platform) {
  Platform["PC"] = "pc";
  Platform["APP"] = "app";
})(Platform || (Platform = {}));
var Env;
(function (Env) {
  Env["Test"] = "test";
  Env["Uat"] = "uat";
  Env["Staging"] = "staging";
  Env["Live"] = "live";
})(Env || (Env = {}));
var EventType;
(function (EventType) {
  // SDK相关
  EventType["BeforeInit"] = "beforeInit";
  EventType["Init"] = "init";
  EventType["IsNotMasterInit"] = "isNotMasterInit";
  EventType["Error"] = "error";
  EventType["Connect"] = "connecting";
  EventType["Connected"] = "connected";
  EventType["Queueing"] = "queueing";
  EventType["Chatting"] = "chatting";
  EventType["CancelQueue"] = "cancelQueue";
  EventType["EndChat"] = "endChat";
  EventType["Quit"] = "quit";
  EventType["UpdateReadedMessage"] = "updateReadedMessage";
  EventType["AddMessage"] = "addMessage";
  EventType["UpdateQueuePosition"] = "updateQueuePosition";
  EventType["EntryClick"] = "handleClickEntry";
  EventType["PushMessage"] = "pushMessage";
  EventType["GetHistory"] = "getHistory";
  EventType["ToggleWindow"] = "toggleWindow";
  EventType["ScrollToTarget"] = "scrollToTarget";
  EventType["PushContactUsAgainMessage"] = "pushContactUsAgainMessage";
  EventType["BlockIncoming"] = "blockIncoming";
  EventType["SetOldestMessageId"] = "setOldestMessageId";
  EventType["ChatWithAgent"] = "chatWithAgent";
  EventType["PushLivechatMessageList"] = "pushLivechatMessageList";
  // 页面相关事件
  EventType["PopWebView"] = "popWebView";
})(EventType || (EventType = {}));
var ErrorType;
(function (ErrorType) {
  ErrorType["Fuse"] = "fuse"; // 熔断,
})(ErrorType || (ErrorType = {}));
var project_name = "cschannel";
var module_name = "livechatfe";
var install = {
  commands: []
};
var build = {
  commands: ["yarn build"],
  upload_static: {
    static_dir: "dist",
    enable_cdn: true,
    cdn_envs: ["staging", "live"]
  },
  docker_image: {
    base_image: "harbor.shopeemobile.com/shopee/nodejs-base:14",
    dependent_libraries_files: ["package.json", "yarn.lock", ".npmrc"],
    run_commands: ["yarn cache clean", "npm install -g n", "n 14.17.3", "yarn install --ignore-engines", "pip install -U shopee-deploy-common"]
  }
};
var deploy$1 = {
  idcs: {
    live: {
      sg: ["sg8"],
      my: ["sg8"],
      th: ["sg8"],
      ph: ["sg8"],
      vn: ["sg8"],
      id: ["sg8"],
      tw: ["sg8"],
      br: ["sg8"],
      cn: ["sg8"],
      mx: ["sg8"],
      co: ["sg8"],
      cl: ["sg8"],
      ar: ["sg8"],
      pl: ["sg8"],
      fr: ["sg8"],
      es: ["sg8"],
      "in": ["sg8"],
      kr: ["sg8"]
    }
  }
};
var require$$0 = {
  project_name: project_name,
  module_name: module_name,
  install: install,
  build: build,
  deploy: deploy$1
};
var deploy = require$$0;
var SiteSuffixForRegion = {
  'th': 'co.th',
  'tw': 'tw',
  'vn': 'vn',
  'id': 'co.id',
  'my': 'com.my',
  'br': 'com.br',
  'sg': 'sg',
  'ph': 'ph',
  'cn': 'cn',
  'mx': 'com.mx',
  'ar': 'com.ar',
  'pl': 'pl',
  'es': 'es',
  'co': 'com.co',
  'cl': 'cl',
  'kr': 'kr',
  'jp': 'jp'
};
var staticPublicPathMap = {
  shopee: {
    live: 'https://cs.deo.shopeemobile.com/shopee/shopee-${projectName}-${env}-${region}',
    staging: 'https://cs.deo.shopeemobile.com/shopee/shopee-${projectName}-${env}-${region}',
    default: 'https://help.${env}.shopee.${regionSuffix}'
  },
  shopeeCn: {
    live: 'https://deo.shopeesz.com/shopee/shopee-${projectName}-${env}-${region}',
    staging: 'https://deo.shopeesz.com/shopee/shopee-${projectName}-${env}-${region}',
    default: 'https://help.${env}.shopee.${regionSuffix}'
  },
  bank: {
    default: 'https://chatbot.${env}.seabank.ph'
  },
  bankID: {
    default: 'https://chatbot.${env}.seabank.co.id'
  },
  bankSG: {
    uat: 'https://chatbot.uat.npt.maribank.com.sg',
    default: 'https://chatbot.${env}.maribank.com.sg'
  }
};
// 入口publicPath
var entryPublicPathMap = {
  shopee: {
    default: 'https://help.${env}.shopee.${regionSuffix}'
  },
  shopeeCn: {
    default: 'https://help.${env}.shopee.${regionSuffix}'
  },
  bank: {
    default: 'https://chatbot.${env}.seabank.ph'
  },
  bankID: {
    default: 'https://chatbot.${env}.seabank.co.id'
  },
  bankSG: {
    uat: 'https://chatbot.uat.npt.maribank.com.sg',
    default: 'https://chatbot.${env}.maribank.com.sg'
  }
};
function getPublicPath(env, region, platform, tenant, isEntry) {
  var buildRegion = (region || process.env.REACT_APP_REGION || 'sg').toLocaleLowerCase();
  var envServer = env || process.env.REACT_APP_SERVER_ENV || 'live';
  var projectName = deploy.project_name;
  var deployModuleName = deploy.module_name;
  var currentTenant = tenant || 'shopee';
  if (currentTenant === 'shopee' && buildRegion === 'cn') {
    currentTenant = 'shopeeCn';
  }
  var publicPathMap = isEntry ? entryPublicPathMap : staticPublicPathMap;
  var publicPathPath = publicPathMap[currentTenant][envServer] || publicPathMap[currentTenant].default || '';
  var currentPublicPath = publicPathPath.replace(/\${region}/g, buildRegion.toLowerCase()).replace(/\${regionSuffix}/g, SiteSuffixForRegion[buildRegion.toLowerCase()] || '').replace(/\${env}/g, envServer).replace(/\${projectName}/g, projectName).replace(/\.live\./g, '\.');
  return "".concat(currentPublicPath, "/").concat(deployModuleName, "/").concat(platform || 'pc', "/");
}
var publicPath = {
  getPublicPath: getPublicPath
};
var buildTime = 'Fri Nov 08 2024 19:21:21 GMT+0800 (中国标准时间)';
var buildEnv = 'live';
var buildRegion = 'sg';
var Version = "0.1.0";
var packageName = "channel-live-chat";
function getPackageName() {
  return packageName.replace('@', '').replace('/', '-');
}
function getSource(platform, version) {
  return getPackageName() + "-" + (platform || Platform.PC) + "-" + (version || Version) + ".js";
}
function getPublic(env, region, platform, tenant) {
  return publicPath.getPublicPath(env, region, platform, tenant, true);
}
var sourceLoaded = false;
var LiveChatBootstrap = {
  version: Version,
  buildTime: buildTime,
  buildEnv: buildEnv,
  buildRegion: buildRegion,
  load: function load(env, region, platform, tenant, version, userLanguage, accessPlatform) {
    if (platform === void 0) {
      platform = Platform.PC;
    }
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
          var cdnPrefix = getPublic(env, region, platform, tenant);
          var loaderSource = getSource(platform, version) + "?timestamp=" + Date.now();
          var s = document.createElement('script');
          s.async = true;
          s.src = "" + cdnPrefix + loaderSource;
          s.onload = function () {
            sourceLoaded = true;
            resolve(true);
          };
          document.body.appendChild(s);
          window.CsLiveChat = {
            userLanguage: userLanguage,
            accessPlatform: accessPlatform
          };
        })];
      });
    });
  },
  init: function init(options) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, env, region, _b, platform, tenant, version, userLanguage, accessPlatform;
      return __generator(this, function (_c) {
        if (!sourceLoaded) {
          _a = options || {}, env = _a.env, region = _a.region, _b = _a.platform, platform = _b === void 0 ? Platform.PC : _b, tenant = _a.tenant, version = _a.version, userLanguage = _a.userLanguage, accessPlatform = _a.accessPlatform;
          LiveChatBootstrap.load(env, region, platform, tenant, version, userLanguage, accessPlatform);
        }
        return [2 /*return*/, new Promise(function (resolve) {
          if (!window.LiveChatSDK) {
            // 未初始化则等待ready后初始化
            window.onLiveChatReady = function () {
              resolve(window.LiveChatSDK);
            };
          } else {
            resolve(window.LiveChatSDK);
          }
        })];
      });
    });
  }
};
export { LiveChatBootstrap };
if (typeof window !== 'undefined') window._CHANNEL_LIVE_CHAT_ = '0.1.0';